export default [{
  path: 'workorder/:leftid/:parent_id',
  name: 'backend_workorder',
  component: () => import('@/views/backend/admin/workorder/list'),
  meta: {
    tpflag: 'backend',
    title: '工单列表',
  }
}, {
  path: 'workordernew/:leftid/:parent_id',
  name: 'backend_workordernew',
  component: () => import('@/views/backend/admin/workorder/new'),
  meta: {
    tpflag: 'backend',
    title: '工单列表-新增工单',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_workorder.js